import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient from 'utils/http-client';
import { handleError } from 'utils/utils';
import {
  createNewSessionFail,
  createNewSessionSuccess,
  fetchAllExistingTermsStart,
} from '../actions';
import configActionTypes from '../types';

export function* createNewSession({ payload }) {
  try {
    let onboardingCallback = () => {};
    if (payload.hasOwnProperty('onboardingCallback')) {
      onboardingCallback = payload.onboardingCallback;
      delete payload.onboardingCallback;
    }
    const response = yield httpClient.post(`/terms/multiple`, payload?.terms);
    yield put(createNewSessionSuccess(response.data));
    Notify('Session started successfully. Set the current term.', { position: 'top-right' });
    payload.callback();
    yield put(fetchAllExistingTermsStart());
    onboardingCallback();
  } catch (error) {
    yield put(createNewSessionFail(error.fail));
    const err = handleError(error);
  }
}

export function* onCreateNewSessionStart() {
  yield takeLatest(configActionTypes.CREATE_NEW_SESSION_START, createNewSession);
}
